// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2H5JV","label":"styles_label__A64xP"};